import { Heading } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { BaseLayout } from '..'
import { colors } from '../../../ui-kit'
import { DiscountedPricingAlertBox } from '../../components/Billing/DiscountedPricing'
import InvoicesTable from '../../components/Billing/InvoicesTable'
import UpcomingInvoice from '../../components/Billing/UpcomingInvoice'
import { MainContentHeadingBox, MainContentWrapper } from '../Base/MainContent'

const InvoicesLayout = (): React.ReactElement => {
  const { t } = useTranslation()

  return (
    <BaseLayout>
      <MainContentHeadingBox>
        <Heading
          as="h5"
          size="md"
          fontWeight="600"
          color={colors.appDarkIndigo}
        >
          {t('invoices', 'Invoices')}
        </Heading>
      </MainContentHeadingBox>
      <MainContentWrapper style={{ gap: '0.5em' }}>
        <DiscountedPricingAlertBox />
        <UpcomingInvoice />
        <InvoicesTable />
      </MainContentWrapper>
    </BaseLayout>
  )
}

export default InvoicesLayout
